import {styled} from "@mui/material/styles"

import {SaleSashPosition} from "../../config/constants"

export const SaleImg = styled("img")`
    width: auto;
    position: absolute;
    z-index: 1;

    &.${SaleSashPosition.TL} {
        /*! @noflip */
        left: 0;
        top: 0;
    }

    &.${SaleSashPosition.TR} {
        /*! @noflip */
        right: 0;
        top: 0;
    }

    &.${SaleSashPosition.BL} {
        /*! @noflip */
        left: 0;
        bottom: 0;
    }

    &.${SaleSashPosition.BR} {
        /*! @noflip */
        right: 0;
        bottom: 0;
    }
`
